import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import "./Membership.css";
import CloudStorage from "../../../CloudStorage/CloudStorage";
import { useNavigate } from "react-router-dom";
import { buythismembershipandupgrate } from "../../../redux/membership/action";
import { useDispatch } from "react-redux";
import { formatNumberWithCommas } from "../../Common/AllDateTimeReleventFormate";
import CustomeDurationLabel from "../../Common/CustomeLabel/CustomeDurationLabel";
import PostNotFound from "../../CustomComponents/AllLoader/PostNotFound";
import { Navigation, Pagination, Mousewheel } from "swiper/modules";

export default function MembershipSwiperSlide({ membershiplist, billingPeriod }) {

  console.log(membershiplist, "membershiplist")
  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const filteredMembershipList = React.useMemo(() => {
    if (!Array.isArray(membershiplist)) return [];

    if (billingPeriod == 'Monthly') {
      return membershiplist.filter(item => item.duration_type == 4);
    } else if (billingPeriod == 'annually') {
      return membershiplist.filter(item => item.duration_type == 6);
    }

    return membershiplist;
  }, [membershiplist, billingPeriod]);

  const buythismembership = (item) => {
    const data = { id: item?.id };
    // dispatch(buythismembershipandupgrate(data));
    navigate(`/${lan}/account/paymentmethodpage`, {
      state: { orderdetails: { type: 14, id: item?.id, post_price: item?.price } },
    });
    // console.log(item, 'itemitemitemitem');

  };

  const [visibleCounts, setVisibleCounts] = useState({});

  const handleLoadMore = (membershipId) => {
    setVisibleCounts((prevCounts) => ({
      ...prevCounts,
      [membershipId]: (prevCounts[membershipId] || 5) + 5,
    }));
  };

  return (
    <div className="swiper-wrapper-sec mt-3 upgarde-member">
      {(Array.isArray(filteredMembershipList) && filteredMembershipList?.length > 0) ? (
        <Swiper
          spaceBetween={30}
          slidesPerView={4}
          modules={[Navigation, Pagination, Mousewheel]}
          navigation={filteredMembershipList.length > 4}
          pagination={{ clickable: true }}
          mousewheel={{
            forceToAxis: true, // maps vertical trackpad swipe to horizontal slide movement
            sensitivity: 1,
            releaseOnEdges: true, // lets page scroll normally once you hit the first/last slide
          }}
          breakpoints={{
            1025: {
              slidesPerView: 4,
              spaceBetween: 20,
            },
            768: {
              slidesPerView: 3,
              spaceBetween: 20,
            },
            0: {
              slidesPerView: 1.3,
              spaceBetween: 10,
            },
          }}
        >
          {filteredMembershipList?.map((item, index) => {
            const visibleCount = visibleCounts[item.id] || 5; // Default to 5 if not set

            return (
              <SwiperSlide key={index}
                touchStartPreventDefault={false}
              >
                <div className="buy-professional">
                  <h4>{item?.title}</h4>
                  <h2>
                    <span>SAR</span>
                    {formatNumberWithCommas(item.price)}
                  </h2>
                  <h6>Per {billingPeriod == 'annually' ? 'year' : 'month'}</h6>
                  <button
                    type="button"
                    onClick={() => buythismembership(item)}
                  >
                    Buy {item?.title}
                  </button>
                  <ul>
                    {Array.isArray(item?.services) &&
                      item?.services.slice(0, visibleCount).map((item1, index) => (
                        <li key={index}>
                          <img
                            src={`${CloudStorage.cloudurl}/Assets/Images/membership/check-circle.svg`}
                            alt=""
                          />
                          {item1?.quantity ? item1?.quantity : ""}{" "}
                          {item1?.services ? item1?.services : ""}{" "}
                          ({item1?.sub_services ? item1.sub_services : ""})
                        </li>
                      ))}
                    {Array.isArray(item?.services) &&
                      item?.services.length > visibleCount && (
                        <label onClick={() => handleLoadMore(item.id)}>
                          Load More
                        </label>
                      )}
                  </ul>
                  <p>Billed monthly. Cancel anytime</p>
                  <p>
                    Expiry :&nbsp;
                    <CustomeDurationLabel
                      duration={item?.duration}
                      duration_type={item?.duration_type}
                    />
                  </p>
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>
      ) :
        <>
          <PostNotFound title={"No Active Memebership"} />
        </>
      }
    </div>
  );
}